// index.js
import http from "./request";

const getMatchSubjectBasicInfo = function (id) {
  const params = { value: id };
  return http.apiPost("MatchSubject/GetBasicInfo", params);
};

const applyInMatchSubject = function (params) {
  return http.apiPost("OutsideBowler/ApplyInMatchSubject", params);
};

const cancelMyApplyInMatchSubject = function (matchSubjectId) {
  const params = { matchSubjectId: matchSubjectId };
  return http.apiPost("OutsideBowler/CancelMyApplyInMatchSubject", params);
};

const GetMatchSubjectBowlerScoreReportWithRank = function (matchSubjectId) {
  const params = { value: matchSubjectId };
  return http.apiPost(
    "MatchReport/GetMatchSubjectBowlerScoreReportWithRank",
    params
  );
};

const MatchSubjectBowlerScoreInTeamReportWithRankInUI = function (
  matchSubjectId
) {
  const params = { value: matchSubjectId };
  return http.apiPost(
    "MatchReport/MatchSubjectBowlerScoreInTeamReportWithRankInUI",
    params
  );
};

const MatchSubjectSessionsBowlerScoreInTeamReportWithRankInUI = function (
  matchSubjectId
) {
  const params = { value: matchSubjectId };
  return http.apiPost(
    "MatchReport/MatchSubjectSessionsBowlerScoreInTeamReportWithRankInUI",
    params
  );
};

const GetMatchScore = function (matchScoreId) {
  const params = { value: matchScoreId };
  return http.apiPost("MatchReport/GetMatchScore", params);
};

const getMyInfoInMatchSubject = function (matchSubjectId) {
  const params = { value: matchSubjectId };
  return http.apiPost("MatchBowler/GetMyInfoInMatchSubject", params);
};

const getAllMatchSubjectAppliesForUser = function () {
  const params = {};
  return http.apiPost(
    "MatchSubjectPublish/GetAllMatchSubjectAppliesForUser",
    params
  );
};

export default {
  getMatchSubjectBasicInfo,
  applyInMatchSubject,
  cancelMyApplyInMatchSubject,
  GetMatchSubjectBowlerScoreReportWithRank,
  MatchSubjectBowlerScoreInTeamReportWithRankInUI,
  MatchSubjectSessionsBowlerScoreInTeamReportWithRankInUI,
  GetMatchScore,
  getMyInfoInMatchSubject,
  getAllMatchSubjectAppliesForUser,
};
